import { duration } from './constants';
import { getPositionVals } from './utils';

export const Animate = () => {
  const xVals = getPositionVals();
  const yVals = getPositionVals();

  return (
    <>
      <animate attributeName="fy" dur={duration} values={xVals} repeatCount="indefinite" />
      <animate attributeName="fx" dur={duration} values={yVals} repeatCount="alternate" />
    </>
  );
};
